import { EnvironmentType } from './environment-type';

export const environment = {
  type: EnvironmentType.develop,
  urlPart: '-dev',
  protocol: 'http',
  useAcl: true,
  baseUrl: 'http://media-basicstudios-basicnet-dev.azurewebsites.net',
  apiUrl: 'http://media-basicstudios-basicnet-dev.azurewebsites.net/api',
  auth: {
    type: EnvironmentType.develop,
    urlPart: '.dev',
    protocol: 'http',
    deployPath: 'scripts/dist/dev'
  },
  frontendUrl: 'http://media-basicstudios-basicnet-dev.azurewebsites.net'
};
